export default {
  searchText(state) {
    return state.searchText;
  },
  stringFilter(state) {
    if (!state.searchText) {
      return '';
    }
    return `(descricao like '%${state.searchText.toLowerCase()}%' or codigoInterno like '%${state.searchText.toLowerCase()}%')`;
  },
};
